module.exports = __webpack_public_path__ + "static/media/sublevel.e7e43ab4.svg";